import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import first from "../images/panel-exvrtise/1.png";
import second from "../images/panel-exvrtise/2.png";
import third from "../images/panel-exvrtise/3.png";
import fourth from "../images/panel-exvrtise/4.png";
import fifth from "../images/panel-exvrtise/5.png";
import sixth from "../images/panel-exvrtise/6.png";
import seventh from "../images/panel-exvrtise/7.png";


function Offer() {
  return (
    <section className="offer-section" style={{ padding: "15rem 0" }}>
      <div className="container" >
        <div className="offer-content">
          <h1 style={{
            fontSize: "3.5rem",
            textAlign: "center",
            marginBottom: "2rem",
            color: "#ff4d30"
          }}>
            Offer Manager
          </h1>

          <p style={{
            fontSize: "1.8rem",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#706f7b"
          }}>
            A revolutionary platform that will allow you to effectively manage the publication of your car sales advertisements.
          </p>

          <div className="main-img" style={{
            width: "100%",
            height: "700px",
            marginTop: "10rem",
            marginBottom: "10rem"
          }}>
            <img
              src={seventh}
              alt="first"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "10px",

              }}
            />
          </div>

          <Swiper
            navigation={true}
            modules={[Navigation]}
            className="offer-swiper"
            slidesPerView={3}
            spaceBetween={30}
            loop={true}
          >
            <SwiperSlide>
              <img src={first} alt="Slider 1" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={second} alt="Slider 1" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={third} alt="Slider 2" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={fourth} alt="Slider 3" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={fifth} alt="Slider 4" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={sixth} alt="Slider 5" style={{ width: "100%", height: "275px", objectFit: "cover" }} />
            </SwiperSlide>

          </Swiper>
          <div style={{ padding: "10rem 0" }}>
            <div style={{ marginBottom: "5rem" }}>
              <img
                src={require("../images/offer/6.webp")}
                alt="offer"
                style={{
                  width: "35%",
                  height: "250px",
                  objectFit: "cover",
                  borderRadius: "10px"
                }}
              />
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "3rem",
              marginTop: "5rem"
            }}>
              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  Standardization of created offers
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  Create complete ads based on a set standard. Using our platform helps you avoid mistakes and omissions of information. No matter which employee is currently creating the offer, with our software all announcements will maintain a uniform standard.
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  One-click publication of offers on portals
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  Save time! Thanks to the automation we have developed, you are only one click away from exporting your offers to all leading advertising portals. Changes made from within Offer Manager are implemented across all publication sites.
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  E-commerce publishing
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  In addition to automating the publication of your ad in well-known media, we also took care of the ability to integrate ads created in VC360 Offer Manager with your e-commerce system.
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  Management of photos and virtual garage
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  VC360 Offer Manager is a well thought out tool for cataloguing and managing the effects of car photo shoots.
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  Preparation and presentation of offers in 360° technology
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  An element of our system is Player360, which enables interactive publication of 360 photos with the use of hotspots, i.e. the option of selecting important elements of the vehicle and placing their close-ups. This solution increases engagement among users, keeping their attention for longer.
                </p>
              </div>

              <div className="offer-box">
                <h3 style={{ fontSize: "2.4rem", marginBottom: "2rem", color: "#ff4d30" }}>
                  Full integration with Euro Tax & Individual implementations
                </h3>
                <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                  Thanks to the integration with the Euro Tax central database, we have simplified and standardised the process of creating an announcement. Our platform can be connected to other databases, and we realise individual implementations for sales networks.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="how-section" style={{ padding: "8rem 0" }}>
          <div className="how-content" style={{ display: "flex", alignItems: "center", gap: "5rem" }}>
            <div className="how-content__text" style={{ flex: "1" }}>
              <h3 style={{ fontSize: "3rem", marginBottom: "4rem", color: "#ff4d30" }}>How does it work?</h3>

              <div className="how-steps" style={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>1. Data input</h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    Fill in your advert with the details of the vehicle you are selling. The integration with Euro Tax will help you do this.
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>2. Selection of photos</h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    Choose professionally prepared photographic content and 360 presentations.
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>3. Export of the offer</h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    Publish your ad on the portals of your choice and your own e-commerce system.
                  </p>
                </div>

                <div className="step">
                  <h4 style={{ fontSize: "2rem", marginBottom: "1rem" }}>4. Manage your advertisements</h4>
                  <p style={{ fontSize: "1.6rem", lineHeight: "1.6", color: "#706f7b" }}>
                    Make changes and keep your offer up-to-date from one place, without having to log into your supported ad portals.
                  </p>
                </div>
              </div>
            </div>

            <div className="how-content__img" style={{ flex: "1" }}>
              <img
                src={require("../images/models/banner2.webp")}
                alt="how it works"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </div>
          </div>
        </div>
        <div className="iframe-container" style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%" }}>
          <iframe
            src="https://panel.exvrtise.com/carviewer/view/664356729f2d2330f0adbed6"
            style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none" }}
            title="360 Vehicle Inspection"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}

export default Offer;
